// extracted by mini-css-extract-plugin
export var heroContainer = "product-hero-module--hero-container--A17wh";
export var heroImage = "product-hero-module--hero-image--aUBnW";
export var mediaThumbnail = "product-hero-module--media-thumbnail--U1SCG";
export var swiperContainer = "product-hero-module--swiper-container--ADhj6";
export var thumbnailImage = "product-hero-module--thumbnail-image--JpgMT";